import { useEffect } from 'react';
import { useValidationStore } from '../store/validation.store';
import { logger } from '@/features/help/utils/logger';

// Purpose: Custom hook to handle field validation UI feedback
export const useFieldValidation = (fieldId: string) => {
  const { invalidFields } = useValidationStore();
  const isInvalid = invalidFields.includes(fieldId);

  // Add visual feedback for invalid fields
  useEffect(() => {
    // Find the field element
    const fieldElement = document.getElementById(`field-${fieldId}`);

    if (isInvalid && fieldElement) {
      // Add a highlight class
      fieldElement.classList.add('border-red-500');
      fieldElement.classList.add('bg-red-50');

      // Scroll to the first invalid field
      if (invalidFields[0] === fieldId) {
        setTimeout(() => {
          fieldElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

          // Add a brief flash animation
          fieldElement.classList.add('animate-pulse');
          setTimeout(() => {
            fieldElement.classList.remove('animate-pulse');
          }, 1000);
        }, 100);
      }

      logger.debug('FieldValidation', 'Highlighted invalid field', {
        fieldId,
        isFirstInvalid: invalidFields[0] === fieldId,
      });
    } else if (fieldElement) {
      // Remove highlight classes if not invalid
      fieldElement.classList.remove('border-red-500');
      fieldElement.classList.remove('bg-red-50');
      fieldElement.classList.remove('animate-pulse');
    }

    // Clean up the highlight when component unmounts or validation state changes
    return () => {
      if (fieldElement) {
        fieldElement.classList.remove('border-red-500');
        fieldElement.classList.remove('bg-red-50');
        fieldElement.classList.remove('animate-pulse');
      }
    };
  }, [fieldId, isInvalid, invalidFields]);

  return {
    isInvalid,
  };
};
